import axios from 'axios';
import { getToken, setToken } from '../utils/tokenStorage';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor: attach Bearer token when available
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle session expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response;
  },

  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response;
  },

  getCurrentUser: async () => {
    return await api.get('/auth/me');
  },

  logout: async () => {
    await api.post('/auth/logout');
  },

  isAuthenticated: () => false, // Auth state is managed by AuthContext; httpOnly cookies are not readable client-side

  refreshToken: async () => {
    const response = await api.post('/auth/refresh-token');
    // Persist the rotated token so native apps keep working
    if (response.data?.data?.token) {
      await setToken(response.data.data.token);
    }
    return response;
  },

  resetPassword: async (email) => {
    return await api.post('/auth/forgot-password', { email });
  }
};

export default authService;
